import React, { useState } from 'react';
import Header from "./partials/Header";
import { useNavigate } from "react-router-dom";
import AccountIntro from './partials/AccountIntro';
import { setAuthCookie } from './utils/cookies';

export default function Signin() {
    const API_AUTH_URL = process.env.REACT_APP_AUTH_API_URL;

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }

        if (errors.general) {
            setErrors(prev => ({
                ...prev,
                general: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {};

        if (!formData.username) newErrors.username = 'Campo obbligatorio';
        if (!formData.password) newErrors.password = 'Campo obbligatorio';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);

        try {
            const credentials = btoa(`${formData.username}:${formData.password}`);

            const response = await fetch(
                `${API_AUTH_URL}/auth/login`,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Basic ${credentials}`,
                    },
                }
            );

            if (response.status !== 200) {
                throw new Error('Credenziali non valide');
            }

            if (!response.ok) {
                throw new Error('Errore del server');
            }

            // Ottiene header Authorization
            const authHeader = response.headers.get('Authorization');
            if (!authHeader || !authHeader.startsWith('Bearer')) {
                throw new Error('Errore nella risposta');
            }

            const token = authHeader.replace('Bearer ', '');

            // Crea cookie MMAUTH
            setAuthCookie(token);

            // Redirect dopo login
            navigate("/profilo");
            window.scrollTo(0, 0);
        } catch (error) {
            setErrors({
                general: error.message || 'Errore durante il login'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleSignup = () => {
        navigate("/registrazione");
        window.scrollTo(0, 0);
    };

    return (
        <div className="ef-page ef-auth-page ef-account-page ef-login-page min-h-screen">
            <Header />

            <AccountIntro title="Bentornato in Easy Funeral.">Accedi alla tua area riservata per gestire il profilo della tua agenzia.</AccountIntro>

            <form onSubmit={handleSubmit}>
                <div className="max-w-2xl mx-auto signup-form-background border-radius md:shadow-2xl p-6 space-y-7 mb-6">
                    {errors.general && (
                        <p role="alert" className="ef-account-notice ef-account-notice--error">
                            {errors.general}
                        </p>
                    )}

                    <div>
                        <label htmlFor="login-username" className="block font-bold mb-2">
                            Nome utente
                        </label>
                        <input
                            type="text"
                            name="username"
                            id="login-username"
                            autoComplete="username"
                            autoCapitalize="none"
                            required
                            placeholder="Inserisci il nome utente"
                            value={formData.username}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 bg-gray-200 border-radius focus:outline-none focus:ring-2 focus:ring-primary transition"
                        />
                        {errors.username && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.username}
                            </p>
                        )}
                    </div>

                    <div>
                        <label htmlFor="login-password" className="block font-bold mb-2">
                            Password
                        </label>
                        <input
                            type="password"
                            name="password"
                            id="login-password"
                            autoComplete="current-password"
                            required
                            placeholder="Inserisci la password"
                            value={formData.password}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 bg-gray-200 border-radius focus:outline-none focus:ring-2 focus:ring-primary transition"
                        />
                        {errors.password && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.password}
                            </p>
                        )}
                    </div>

                    <div>
                        <button
                            type="submit"
                            disabled={loading}
                            className={`bg-primary w-full text-white py-2 text-lg border-radius ${
                                loading ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                        >
                            {loading ? 'Accesso in corso...' : 'Accedi alla tua area'}
                        </button>
                        <div className="text-center text-black mt-3">
                            <a href="/recupera-password"><u>Password dimenticata?</u></a>
                        </div>
                    </div>

                    <div className="ef-auth-alternative">
                        <h2 className="text-xl text-center font-bold">Non hai un account?</h2>
                        <button
                            type="button"
                            onClick={handleSignup}
                            className="ef-account-secondary w-full py-2 border-radius mt-4"
                        >
                            Registrati ora
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}
